import * as themes from '../theming';
export const changeTheme = (theme) => {
    const root = document.documentElement;
    const selectedTheme = themes[theme];
    Object.entries(selectedTheme).forEach(([name, value]) => {
        root.style.setProperty(name, value);
    });
};
